/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-test-item-organism-antibiotic.reducer';

export const LabTestItemOrganismAntibioticDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labTestItemOrganismAntibioticEntity = useAppSelector(state => state.labTestItemOrganismAntibiotic.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labTestItemOrganismAntibioticDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.detail.title">LabTestItemOrganismAntibiotic</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.id">Id</Translate>
            </span>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.id}</dd>
          <dt>
            <span id="suggestedBy">
              <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.suggestedBy">Suggested By</Translate>
            </span>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.suggestedBy}</dd>
          <dt>
            <span id="micSusceptible">
              <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.micSusceptible">Mic Susceptible</Translate>
            </span>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.micSusceptible}</dd>
          <dt>
            <span id="micIntermediate">
              <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.micIntermediate">Mic Intermediate</Translate>
            </span>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.micIntermediate}</dd>
          <dt>
            <span id="micResistant">
              <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.micResistant">Mic Resistant</Translate>
            </span>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.micResistant}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.notes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.active">Active</Translate>
            </span>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.source">Source</Translate>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.source ? labTestItemOrganismAntibioticEntity.source.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.labTestItem">Lab Test Item</Translate>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.labTestItem ? labTestItemOrganismAntibioticEntity.labTestItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.organism">Organism</Translate>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.organism ? labTestItemOrganismAntibioticEntity.organism.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.antibiotic">Antibiotic</Translate>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.antibiotic ? labTestItemOrganismAntibioticEntity.antibiotic.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.lab">Lab</Translate>
          </dt>
          <dd>{labTestItemOrganismAntibioticEntity.lab ? labTestItemOrganismAntibioticEntity.lab.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lab-test-item-organism-antibiotic" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-test-item-organism-antibiotic/${labTestItemOrganismAntibioticEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabTestItemOrganismAntibioticDetail;
